'use client';

import {Skeleton} from "@/components/ui/shadcn/skeleton";
import {cn} from "@/lib/utils";
import Image, {ImageProps} from "next/image";
/**
 * Custom Image which has the skeleton built in
 */
import * as React from "react";
import {useState} from "react";


interface CustomImageProps extends ImageProps {
    className?: string;
    skeletonClassName?: string;
    onClick?: () => void;
    children?: React.ReactNode;

    // [key: string]: unknown;
}

const CustomImage = React.forwardRef<HTMLImageElement, CustomImageProps>(
    (
        {


            className,
            skeletonClassName,
            ...rest
        },

        ref
    ) => {


        const [isLoading, setIsLoading] = useState(true);

        const loadCallback = () => {
            console.log('image loaded', rest.src);
            setIsLoading(false)
        }
        return (
            <div
                className={cn(
                    "relative",
                    "flex",
                    "justify-center"
                )}>
                {isLoading && (
                    <Skeleton className={
                        cn("absolute h-full rounded-md",
                            `w-[${rest.width}px]`,
                            skeletonClassName
                        )}/>
                )}
                <Image
                    width={rest.width}
                    height={rest.height}
                    className={
                        cn("object-scale-down h-64 w-full transition-opacity duration-5",
                            className,
                            isLoading ? 'opacity-0' : 'opacity-100'
                        )}
                    onLoad={loadCallback}
                    {...rest}
                />
            </div>);


    });
CustomImage.displayName = "CustomButton";

export default CustomImage;
